import React from 'react';
import type { DialogProps } from '@mui/material';
import { Box, Dialog } from '@mui/material';

interface CustomDialogProps extends DialogProps {
  id: string;
  open: boolean;
  onClose?: DialogProps['onClose'];
  fullScreen?: boolean;
  fullWidth?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  disableEscapeKeyDown?: boolean;
  showCloseIcon?: boolean;
  className?: string;
  ariamodal?: boolean;
  scroll?: 'paper' | 'body';
  children: React.ReactNode;
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  id,
  open,
  onClose,
  fullScreen = false,
  fullWidth = false,
  maxWidth = 'sm',
  disableEscapeKeyDown = false,
  className = '',
  ariamodal = true,
  scroll = 'paper',
  children,
  ...props
}) => {
  return (
    <Box>
      <Dialog
        id={id}
        open={open}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return;
          onClose?.(event, reason);
        }}
        fullScreen={fullScreen}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        disableEscapeKeyDown={disableEscapeKeyDown}
        className={className}
        aria-modal={ariamodal}
        scroll={scroll}
        {...props}
      >
        {children}
      </Dialog>
    </Box>
  );
};

export default CustomDialog;
